import { render } from "./batchDelivery.vue?vue&type=template&id=5a20cc50&scoped=true"
import script from "./batchDelivery.vue?vue&type=script&lang=js"
export * from "./batchDelivery.vue?vue&type=script&lang=js"

import "./batchDelivery.vue?vue&type=style&index=0&id=5a20cc50&lang=css"
import "./batchDelivery.vue?vue&type=style&index=1&id=5a20cc50&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a20cc50"]])

export default __exports__